import { onFieldChangeStateComparison } from '../onFieldChangeStateComparison';
import { simpleFieldTracking } from '../formTracking';
import {
    ON_BEHALF_OF_CHILD_SET_VALUE,
    LEGAL_GUARDIAN_SET_VALUE,
    HAS_OTHER_TAX_FREE_PLAN_SET_VALUE,
} from '../../../actions/taxFreeSavingsAccount/investmentSetupInitial';

import {
    getOnBehalfOfChild,
    getLegalGuardian,
    getHasOtherTaxFreePlan,
} from '../../../selectors/taxFreeSavingsAccount/investmentSetupInitial';
import { fireGtmEvent } from '../gtmEvents';

let hasFormStarted = false;

export const investmentSetupInitialFieldTracking = (store, next, action) => {
    const prevState = store.getState();
    const result = next(action);
    const currentState = store.getState();
    const onFieldChange = onFieldChangeStateComparison(prevState, currentState);
    let sendValue = true;
    let sendError = true;

    const fieldSelector = (() => {
        switch (action.type) {
            case ON_BEHALF_OF_CHILD_SET_VALUE:
                sendError = false;
                return getOnBehalfOfChild;
            case LEGAL_GUARDIAN_SET_VALUE:
                sendError = false;
                return getLegalGuardian;
            case HAS_OTHER_TAX_FREE_PLAN_SET_VALUE:
                sendError = false;
                return getHasOtherTaxFreePlan;
            default:
                return null;
        }
    })();

    const field = onFieldChange(fieldSelector);

    if (!hasFormStarted && field) {
        hasFormStarted = true;

        fireGtmEvent('form_begin', {
            form_name: 'TFSA'
        });

        fireGtmEvent('application_form_start', {
            form_name: 'TFSA',
            application_step: '1',
            application_name: 'Investment Setup Initial',
        });
    }

    if (field) {
        simpleFieldTracking({ action, field, sendValue, sendError });
    }

    return result;
};
